import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import Skeleton from "react-loading-skeleton";
import { CancelIcon, EditIcon, SearchesCIcon } from '../../../SvgIconsData'
import axios from 'axios';
import { useSelector } from 'react-redux';

const PassingCriteriaPage = ({listLoading, list}) => {
  var navigate = useNavigate();
  const [search, setSearch] = useState("");
  const userData = useSelector(state => state.userSlice);
  const configData = useSelector((state) => state.configSlice);

  return (
    <>
      <div className=' container-fluid p-0 pb-0 pt-1 bg-grey-main '>
        <p style={{ background: '#fff', marginBottom:"0",  padding: '20px', fontSize: '14px', borderRadius: '10px', color: '#000', marginTop: '5px' }}>
              Customize the passing criteria for assigned courses based on your organization's unique requirements. Modify the following factors:<br />
              <strong>Criteria Type:</strong> Choose the combination of factors for evaluation.<br />
              <strong>Time Deviation:</strong> Set an acceptable time variation from the ideal completion time (e.g., 20% allows 80%-120% of ideal time).<br />
              <strong>Step Deviation:</strong> Define the maximum acceptable error percentage (e.g., 20% means a maximum of 20% incorrect steps are allowed).<br />
              <strong>Minimum Passes:</strong> Set the minimum number of times the user has to pass the course before achieving the certificate (e.g., 2 times).<br />
              <br />
              Please note that some modules have <strong>"Critical Steps."</strong> Users must complete all critical steps for successful evaluation, even if they meet the Step Deviation criterion.
              Customize now to align course evaluations with your organization's specific goals and learning objectives.<br />
          </p>
        <div className='title-stuff mt-3'>
          <p>Courses List</p>
          <div className='d-flex'>
              <form className=" app-search app-search1 d-flex justify-content-end ">
                <div className="position-relative">
                  <SearchesCIcon />
                  {search.length > 0 && (
                    <span className="searchiconcancel" onClick={() => setSearch("")}>
                      <CancelIcon />
                    </span>
                  )}

                  <input
                    type="text"
                    value={search}
                    name="searchName"
                    className="form-control"
                    placeholder="Search"
                    autoComplete="off"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </form>
          </div>
        </div>
        <div className="table-responsive workflowtb stickyhead mt-3">
                            <table className="table align-middle table-nowrap mb-0">
                                <thead >
                                    <tr>
                                    <th>Courses</th>
                                        <th className="text-center">Minimum Pass</th>
                                        <th className="text-center">Max Hint Allowed</th>
                                        <th className="text-center">Critical (%)</th>
                                        <th className="text-center">Time (%)</th>
                                        <th className="text-center">Errors (%)</th>
                                        <th style={{textAlign:'center'}}>Quiz (%)</th>
                                        <th style={{textAlign:'center'}}>Overall (%)</th>
                                        <th style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>

                                  { listLoading ? 
                                      Array.from({ length: 5 }).map((_, index) => (
                                        <tr key={index}>
                                          <td><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                          <td className='text-center'><Skeleton width="5vw" /></td>
                                        </tr>
                                      ))
                                  :
                                  <>
                                  { list.map((item, index) => {
                                    if (search.length > 0 && !item.name.toLowerCase().includes(search.toLowerCase())) return null;
                                    return(
                                      <tr key={index}>
                                      <td> <div className="form-check"> {item.name} </div> </td>
                                      <td className="text-center"> {item?.passingCriteria?.minimumSuccess || "" } </td>
                                      <td className="text-center"> {item?.passingCriteria?.maxHintAllowed || "" } </td>
                                      <td className="text-center"> {item?.passingCriteria?.critical *100 || "" } </td>
                                      <td className="text-center"> {item?.passingCriteria?.time*100 || "" } </td>
                                      <td className="text-center"> {item?.passingCriteria?.errors*100 || "" } </td>
                                      <td className="text-center"> {item?.passingCriteria?.quiz*100 || "" } </td>
                                      <td className="text-center">
                                          <div className="d-flex justify-content-center"> {item.passingCriteria.min_score_to_pass } </div>
                                      </td>
                                      <td className="align-middle text-center userdrop d-flex align-items-center justify-content-center">
                                          <span className='options' onClick={() => navigate(`/set/passing/criteria/${item.uuid}`, {state:{name : item.name}})}>  <EditIcon /> </span>                                             
                                      </td>
                                      </tr>
                                  )
                                  })}
                                  </>

                                  }
                                 
                                </tbody>
                            </table>
                            </div>
      </div>
    </>
  )
}

export default PassingCriteriaPage
